import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const CardNews = styled.div`
    display: flex;
    flex-direction: ${props => props.isFirstItem ? 'row' : 'column'};
    flex-wrap: nowrap;
    width: 100%;

    @media screen and (max-width: 768px) {
        flex-wrap: wrap;
    }
`;

export const CardPictureWrap = styled.div`
    flex: 0 0 auto;
    position: relative;
    overflow: hidden;
    font-size: 0;
    padding-bottom: 50%;

    ${props => props.isFirstItem
    ? `
        width: 48.6%;
        margin-right: 2.4%;
        padding-bottom: 26.4%;
    `
    : ''}

    @media screen and (max-width: 768px) {
        ${props => props.isFirstItem
        ? `
            width: 100%;
            margin-right: 0;
            padding-bottom: 50%;
        `
        : ''}
    }
`;

export const PictureWrap = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 2 / 1;
`;

export const CardPicture = styled.img`
    width: 100%;
    ${props => props.forSlider
    ? ''
    : `
        position: absolute;
        top: 0;
        left: 0;
        object-fit: cover;
    `}
`;

export const CardPictureTag  = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    user-select: none;
`;

export const CardDescription = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 15px;
`;

export const CardDate = styled.div`
    width: 100%;
    margin-bottom: 8px;
    ${FONTS.XS};
    white-space: nowrap;
`;

export const CardTitle = styled.a`
    width: 100%;
    margin-bottom: 8px;
    ${p => p.isFirstItem ? FONTS.H2 : FONTS.M};
    color: ${COLORS.black};
    white-space: normal;
    transition: color .2s linear;
    ${props => props.isFirstItem
    ? `
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    `
    : ''}

    &:hover {
        color: ${COLORS.red};
    }

    @media screen and (max-width: 1188px) {
        ${p => p.isFirstItem ? FONTS.H3 : FONTS.M};
    }
`;

export const CardText = styled.div`
    width: 100%;
    ${FONTS.S};
    color: ${COLORS.black};
    white-space: normal;
    ${props => props.isFirstItem
    ? `
        ${FONTS.L};
        -webkit-line-clamp: 4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;

        @media screen and (max-width: 1188px) {
            ${FONTS.S};
        }
    `
    : ''}
`;
